import React from 'react'

// material ui
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'

const SectionItem = ({ children }) => {
  return <Box my={4}>{children}</Box>
}

export default SectionItem
